import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-process-list-candidate-points-dialog',
  templateUrl: './process-list-candidate-points-dialog.component.html',
  styleUrls: ['./process-list-candidate-points-dialog.component.scss']
})
export class ProcessListCandidatePointsDialogComponent implements OnInit {

  // candidateData: any;
  isSmallScreen$: Observable<boolean>;
  form: FormGroup;
  submitting: boolean = false;
  score: any;
  points: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private breakpoint: BreakpointObserver,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<ProcessListCandidatePointsDialogComponent>,
    fb: FormBuilder
  ) {
    this.form = fb.group({
      candidateId: [data.candidate.id, Validators.required],
      processListId: [data.processList.id, Validators.required],
      points: [null, [Validators.required, Validators.min(0), Validators.max(10)]]
    });
    this.score = data.candidate.score;
  }

  ngOnInit(): void {

    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => state.matches)
      )

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger } = result;
        this.submitting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject)
    this.getLeadPoint();

  }

  private getLeadPoint() {

    const data = this.form.getRawValue();
    this.http.get('process_list:point', data)
      .subscribe(
        (result: any) => {
          const { data } = result;
          this.form.patchValue({ points: data.pontos });
          this.points = data.pontos
        },
        err => this.errorReport.showMessage(err)
      )

  }

  submit() {

    if (this.form.valid) {

      const data = this.form.getRawValue();
      this.http.save('process_list:point', data)
        .subscribe(
          () => {
            this.dialogRef.close(true);
            this.points = data.points;
          },
          err => this.errorReport.showMessage(err)
        );

    }

  }

  totalScore(): string {
    return (parseFloat(this.points) + parseInt(this.score)).toFixed(2);
  }

}
